// Icons
import { CloseRounded } from '@mui/icons-material';

// Styled
import {
  WrapperDiv,
  IconWrapper,
  NoResultsTitle,
  NoResultsDescriptionWrapper,
  NoResultsDescription,
} from './styled';
import FilterIcon from 'components/Icons/filterIcon';

interface HeaderPropTypes {
  renderCloseIcon?: boolean;
  handleClose?: () => void;
}

const EmptyFilters = ({
  renderCloseIcon = true,
  handleClose,
}: HeaderPropTypes) => {
  return (
    <WrapperDiv>
      <IconWrapper>
        <FilterIcon filled />
      </IconWrapper>
      <NoResultsTitle>No filters applied yet</NoResultsTitle>
      <NoResultsDescriptionWrapper>
        <NoResultsDescription>
          Choose the filter types from the left to apply.
        </NoResultsDescription>
      </NoResultsDescriptionWrapper>
    </WrapperDiv>
  );
};

export default EmptyFilters;
